<template>
<div class="background-window" @click.self="closeThisWindow">
    <div ref="table-consum" class="consumables-window" :class="{wideWinow: userOptions.role == 'developer' || userOptions.role == 'admin'}">
        
        <div class="head-window">
            <h2 class="middle-high">Расходные материалы</h2>
            <button @click="closeThisWindow">
                <img src="@/assets/imgs/crosser-black.svg" alt="">
            </button>
        </div>
        <div class="consum-table-place">
            <el-table :data="consumablesList" style="width: 100%" max-height="250">
                <el-table-column fixed prop="code" label="Код" :width="widthForColumn[0]" />
                <el-table-column prop="name" label="Название" :width="widthForColumn[1]" />
                <el-table-column prop="number" label="Кол." :width="widthForColumn[2]" />
                <el-table-column prop="replace_repeat" label="Периодичность замены,ч" :width="widthForColumn[3]" />
                <el-table-column fixed="right" label="Операции" min-width="80" v-if="userOptions.role == 'developer' || userOptions.role == 'admin'">
                    <template #default="scope">
                        <el-button
                            size="small"
                            type="primary"
                            @click="clickEdit(scope.$index, scope.row)"
                        >Изменить</el-button>
                        <el-button
                            size="small"
                            type="danger"
                            @click="deleteConsumable(scope.$index, scope.row)"
                        >Удалить</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="writing-place-consumables" v-if="showInputPlaceFlag && (userOptions.role == 'developer' || userOptions.role == 'admin')">
                <div class="fields-place">
                    <el-input v-model="tempCodeField" style="width: 150px" placeholder="Код" />
                    <el-input v-model="tempNameField" style="width: 230px" placeholder="Название" />
                    <el-input-number v-model="tempNumberField" style="width: 120px"  />
                    <el-input-number v-model="tempPeriodReplace" style="width: 180px"  />
                </div>
                <div class="button-place">
                    <el-button class="button-writen-place" type="success" plain @click="saveConsumables">Сохранить</el-button>
                    <el-button class="button-writen-place" type="danger" plain @click="showInputPlaceFlag = !showInputPlaceFlag">Отменить</el-button>
                </div>
            </div>
            <el-button style="width: 100%" v-if="!showInputPlaceFlag && (userOptions.role == 'developer' || userOptions.role == 'admin')"  @click="clickAdd">
                Add Item
            </el-button>
        </div>
    </div>
</div>
</template>
<script>
import {  mapGetters, mapActions } from 'vuex'

export default {
    name: 'WindowConsumables',
    data() {
        return {
            showInputPlaceFlag: false,
            workRow: {
                code: '',
                name: '',
                number: 0
            },
            tempEditId: null,
            tempCodeField: '',
            tempNameField: '',
            tempNumberField: 0,
            tempPeriodReplace: 0,
            mode: '',
            widthForColumn: [150, 230, 120, 200]
        }
    },
    props: ['compressorId'],
    emits: ['closeWindow'],
    computed: {
        ...mapGetters('compressor', {
            consumablesList: 'getConsumablesList',
        }),
        ...mapGetters('user', {
            userOptions: 'getUserOptions',
        })
    },
    methods: {
        ...mapActions('compressor', {
            postConsumable: 'postApiConsumable',
            getConsumables: 'getApiConsumables',
            putConsumable: 'putApiConsumable',
            deleteApiConsumable: 'deleteApiConsumable',
        }),
        saveConsumables() {
            if (this.mode == 'post') this.postConsumable({
                id: this.compressorId,
                data: {
                    code: this.tempCodeField,
                    name: this.tempNameField,
                    number: this.tempNumberField,
                    replace_repeat: this.tempPeriodReplace
                }
            });
            else this.putConsumable({
                id: this.tempEditId,
                data: {
                    code: this.tempCodeField,
                    name: this.tempNameField,
                    number: this.tempNumberField,
                    replace_repeat: this.tempPeriodReplace
                }
            })
            this.tempCodeField = '';
            this.tempNameField = '';
            this.tempNumberField = 0;
            this.tempPeriodReplace = 0;
            this.showInputPlaceFlag = !this.showInputPlaceFlag;
            this.mode = '';
        },
        deleteConsumable(index, row) {
            this.deleteApiConsumable(row);
        },
        clickEdit(index, row) {
            this.showInputPlaceFlag = true;
            this.mode = 'put';
            this.tempEditId = row.id
            this.tempCodeField = row.code;
            this.tempNameField = row.name;
            this.tempNumberField = row.number;
            this.tempPeriodReplace = row.replace_repeat;
        },
        clickAdd() {
            this.showInputPlaceFlag = !this.showInputPlaceFlag;
            this.mode = 'post';
            this.tempCodeField = '';
            this.tempNameField = '';
            this.tempNumberField = 0;
            this.tempPeriodReplace = 0;
            this.tempEditId = null;
        },
        closeThisWindow() {
            this.$emit('closeWindow');
        }
    },
    created() {
        this.getConsumables({id: this.compressorId})
    },
    mounted() {
        console.log(this.$refs['table-consum'].offsetWidth)
        if (this.$refs['table-consum'].offsetWidth <= 520 && (this.userOptions.role == 'developer' || this.userOptions.role == 'admin')) {
            this.widthForColumn = [69, 100, 100, 100]
        }
    }
}
</script>
<style noscoped lang="scss">
.consumables-window {
    cursor: auto;
    // width: 40vw;
    padding: 20px 2%;
    border-radius: 4px;
    background: var(--background-white);

    &.wideWinow {
        width: 50vw;
        min-width: 320px;
    }

    .head-window {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;

        button {
            padding: 1px 2px;
            background: none;
            cursor: pointer;
        }
    }

    .consum-table-place {

    }
    .writing-place-consumables {
        display: flex;
        justify-content: space-between;

        .button-writen-place {
            margin-left: 0;
        }
    }
}
@media screen and (max-width: 500px) {
    
    .consumables-window {
        .writing-place-consumables {
            flex-direction: column;
        }
    }
}
</style>